import axios from 'axios/dist/axios';


const defaultState = {
    treeData: null,
    mustShowTestPopup: false,
    mustShowNodePopup: false,
    newTreeData: null,
    runTestData: null,
    responseTestData: null,
    mustShowAddLabelPopup: false,
    testTree: false,
    editLabel: null,
    mustShowMultipleTestsPopup: false,
    progressMultiple: false,
    mustShowTestRunDetailsPopup: false,
    testRunDetails:  {
        productCode: null,
        applicationUrl: null,
        username: null,
        password: null

    }

};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    treeData:                    defaultState.treeData,
    mustShowTestPopup:           defaultState.mustShowTestPopup,
    mustShowNodePopup:           defaultState.mustShowNodePopup,
    newTreeData:                 defaultState.newTreeData,
    runTestData:                 defaultState.runTestData,
    responseTestData:            defaultState.responseTestData,
    mustShowAddLabelPopup:       defaultState.mustShowAddLabelPopup,
    testTree:                    defaultState.testTree,
    editLabel:                   defaultState.editLabel,
    mustShowMultipleTestsPopup:  defaultState.mustShowMultipleTestsPopup,
    progressMultiple:            defaultState.progressMultiple,
    mustShowTestRunDetailsPopup: defaultState.mustShowTestRunDetailsPopup,
    testRunDetails:  {
        productCode:             defaultState.testRunDetails.productCode,
        applicationUrl:          defaultState.testRunDetails.applicationUrl,
        username:                defaultState.testRunDetails.username,
        password:                defaultState.testRunDetails.password

    }
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getTreeData:                    state => state.treeData,
    getMustShowTestPopup:           state => state.mustShowTestPopup,
    getMustShowNodePopup:           state => state.mustShowNodePopup,
    getNewTreeData:                 state => state.newTreeData,
    getRunTestData :                state => state.runTestData,
    getResponseTestData:            state => state.responseTestData,
    getMustShowAddLabelPopup:       state => state.mustShowAddLabelPopup,
    getTestTree:                    state => state.testTree,
    getEditLabel:                   state => state.editLabel,
    getMustShowMultipleTestsPopup:  state => state.mustShowMultipleTestsPopup,
    getProgressMultiple:            state => state.progressMultiple,
    getMustShowTestRunDetailsPopup: state => state.mustShowTestRunDetailsPopup,
    getTestRunDetails:              state => state.testRunDetails
};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    /**
     * Upload json file and commit tree data returned from server.
     * @param {Object} - Vuex: commit
     * @return {Promise}
     */
    uploadJsonAndLoadTreeData ({ commit }, fileToUpload) {
        let promise = new Promise((resolve, reject) => {

            let formData = new FormData();
            formData.append('file', fileToUpload.file);

            let axiosRequest = axios.post(
                process.env.API_BASE_URL + '/test/uploadAndReturnTestTree',
                formData,
                {
                    headers: {
                          'Content-Type': 'multipart/form-data'
                    },
                }
            );
            axiosRequest.then((response) => {
                console.log(response.data);
                commit('setTreeData', response.data.treeRoot[0]);
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            }
            );
        });

        return promise;
    },

    // deleteNodeTree ({ commit }) {
    //     let promise = new Promise((resolve, reject) => {
    //
    //         let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/deleteTestTreeNode', {
    //             nodeId: 3
    //         });
    //         axiosRequest.then((response) => {
    //             console.log("data for tree after delete");
    //             console.log(response.data);
    //             commit('setNewTreeData', response.data.treeRoot[0]);
    //             resolve(response);
    //         });
    //         axiosRequest.catch((error) => {
    //             console.log(error);
    //             reject(error);
    //         });
    //     });
    //
    //     return promise;
    // },

    runTest ({ commit }) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/startTest');

            axiosRequest.then((response) => {
                console.log("run test data");
                console.log(response);
                console.log(response.data);
                commit('setRunTestData', response.data);
                commit('responseRunTestData', 200);
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error.status);
                commit('setRunTestData', null);
                commit('responseRunTestData', error.status);
                reject(error);
            });
        });

        return promise;
    },

    showTestPopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            commit('setMustShowTestPopup', true);
        });

        return promise;
    },

    showNodePopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            commit('setMustShowNodePopup', true);
        });
        return promise;
    },
    showAddLabelPopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            console.log("add label")
            commit('setMustShowAddLabelPopup', true);
        });

        return promise;
    },
    showMultipleTestsPopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            commit('setMustShowMultipleTestsPopup', true);
        });

        return promise;
    },

    /**
     * Upload zip file with multiple json and download.
     * @param {Object} - Vuex: commit
     * @return {Promise}
     */
    multipleUploadAndDownload ({ commit }, fileToUpload) {
        let promise = new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', fileToUpload.file);

            let axiosRequest = axios.post(
                process.env.API_BASE_URL + '/test/uploadAndRunMultipleTests',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    responseType: 'blob'
                },
            );

            axiosRequest.then((response) => {

                /**
                 *  If response status OK Close upload popup and progress bar
                 */
                if(response){
                    commit('setMustShowMultipleTestsPopup', false);
                    setTimeout(function(){
                        commit('setGetProgressMultiple', false);
                    }, 1000)
                }

                const testName = response.headers["file-name-value"];
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), testName); /* IE browser Solution*/
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', testName);
                    document.body.appendChild(link);
                    link.click();
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });

        });

        return promise;
    },
    showTestRunDetailsPopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            commit('setMustShowTestRunDetailsPopup', true);
        });

        return promise;
    },

    testRunDetailsData ({ commit }) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/openTestRunDetails');
            axiosRequest.then((response) => {
                 commit('setTestRunDetails', response.data.testRunDetails);
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    }

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setTreeData (state, data) {
        state.treeData = data;
    },

    setMustShowTestPopup (state, data) {
        state.mustShowTestPopup = data;
    },

    setMustShowNodePopup (state, data) {
        state.mustShowNodePopup = data;
    },
    setNewTreeData (state, data) {
        state.newTreeData = data;
    },
    setRunTestData (state, data) {
        state.runTestData = data;
    },
    clearRunTestData (state) {
        console.log("clear run test data");
        state.runTestData = '';
    },
    responseRunTestData(state, data) {
        state.responseTestData = data;
        console.log(state.responseTestData)
    },
    setMustShowAddLabelPopup (state, data) {
        state.mustShowAddLabelPopup = data;
    },
    setGetTreeData(state, data) {
        console.log("commit to true")
        state.testTree = data;
    },
    setEditLabel (state, data) {
        state.editLabel = data;
    },
    setMustShowMultipleTestsPopup (state, data) {
        state.mustShowMultipleTestsPopup = data;
    },
    setGetProgressMultiple(state, data) {
        state.progressMultiple = data;
    },
    setMustShowTestRunDetailsPopup (state, data) {
        state.mustShowTestRunDetailsPopup = data;
    },
    setTestRunDetails (state, data) {
        state.testRunDetails = data;
    },


    // ----------------------------------------------------------

    resetStore(state) {
        state.treeData                    = defaultState.treeData;
        state.mustShowTestPopup           = defaultState.mustShowTestPopup;
        state.mustShowNodePopup           = defaultState.mustShowNodePopup;
        state.newTreeData                 = defaultState.newTreeData;
        state.runTestData                 = defaultState.runTestData;
        state.responseTestData            = defaultState.responseTestData;
        state.mustShowAddLabelPopup       = defaultState.mustShowAddLabelPopup;
        state.testTree                    = defaultState.testTree;
        state.editLabel                   = defaultState.editLabel;
        state.mustShowMultipleTestsPopup  = defaultState.mustShowMultipleTestsPopup;
        state.progressMultiple            = defaultState.progressMultiple;
        state.mustShowTestRunDetailsPopup = defaultState.mustShowTestRunDetailsPopup;
        state.testRunDetails              = defaultState.testRunDetails;
        state.testRunDetails              = {
                productCode:                defaultState.testRunDetails.productCode,
                applicationUrl:             defaultState.testRunDetails.applicationUrl,
                username:                   defaultState.testRunDetails.username,
                password:                   defaultState.testRunDetails.password

        }
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/TestStore.js